import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Button } from 'react-bootstrap';
import BackIcon from '../../../../styles/images/back-without-bg.png';
import { handleChangeDataBottomSheet } from '../../../../redux/actions/partials/footer/bottom_sheet';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { BASE_SITE, REQUEST_CREDIT_FOR_CASH_PURCHASE } from '../../../../apis'; 
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import Swal from 'sweetalert2';
import axios from "axios";
import SitagLogo from '../../../../styles/images/sitag-logo.png';

const Installments = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { token } = useSelector(state => state.user);

    // useEffect(() => {
    //     console.log('ejra shod');
    // }, [Installments]);

    const handleUploadReqClick = () => {
        navigate('../installments/search?type=upload');
    };

    const handleBuyReqClick = () => {
        navigate('../installments/search?type=buy');
    };

    const handleBackBtn = () => {
        navigate(-1);
    };

    const closeBottomSheet = () => {
        dispatch(handleChangeDataBottomSheet('isOpen', false));
    };

    const buttonsOkCancel = Swal.mixin({
        customClass: {
            confirmButton: 'primary-btn primary-border font-weight-300 radius-12  py-2  ml-3 width-80',
            cancelButton: 'primary-border primary-txt-color font-weight-300 radius-12  py-2 width-80',
        },
        buttonsStyling: false
    });
    const btnOkSingle = Swal.mixin({
        customClass: {
            confirmButton: 'primary-border primary-txt-color font-weight-300 radius-12 w-100 py-2 px-5',
        },
        buttonsStyling: false
    });

    const handleReqCredit = () => {
        buttonsOkCancel.fire({
            text: "شما در حال ثبت درخواست اعتبار جهت خرید نقدی میباشد. درسته؟",
            imageUrl: SitagLogo,
            imageHeight: 80,
            imageAlt: 'سیتگ',
            confirmButtonText: "بله",
            showCancelButton: true,
            cancelButtonText: 'انصراف',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(handleSetBackdropLoading(true));

                axios({
                    method: 'get',
                    url: BASE_SITE + REQUEST_CREDIT_FOR_CASH_PURCHASE,
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': token
                    },
                }).then((response) => {
                    switch (response.data.status) {
                        case 'error':
                            dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                            break;
                        case 'ok':
                            btnOkSingle.fire({
                                title: 'تایید',
                                text: 'درخواست شما با موفقیت ثبت شد',
                                imageUrl: SitagLogo,
                                imageHeight: 80,
                                imageAlt: 'سیتگ',
                                confirmButtonText: "باشه",
                            });
                            break;
                        default:
                            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در ارتباط با سرور! لطفا مجددا تلاش کنید', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                    }
                    dispatch(handleSetBackdropLoading(false));
                }, () => {
                    dispatch(handleSetBackdropLoading(false));
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در ارتباط با سرور! لطفا مجددا تلاش کنید', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                });
            }
        }); 


                
    };

    return (

        <div id="buy-normal-user-page" onClick={closeBottomSheet} >

            <Row className="py-3 white-bg sticky top-0 z-index-2">
                <Col xs={1}><img src={BackIcon} alt="back" onClick={handleBackBtn} /></Col>
                <Col xs={10}><h4 className="text-center">خرید اقساطی</h4></Col>
                <Col xs={1}></Col>
            </Row>
            

            <div className="primary-border p-3" style={{marginTop: "5rem"}}>
                <Row className="mt-1">
                    <Col xs={12}>
                        <Link onClick={handleReqCredit}>
                            <Button className="primary-border bg-secondary primary-txt-color font-weight-300 radius-12 w-100 py-2">
                                درخواست اعتبار جهت خریدهای نقدی
                            </Button>
                        </Link>
                    </Col>
                    <Col xs={12}>
                        <Button className="primary-btn radius-12 w-100 mt-3 py-2" onClick={handleBuyReqClick}>
                            درخواست خرید اقساطی
                        </Button>
                    </Col>
                    <Col xs={12}>
                        <Button className="primary-btn radius-12 w-100 mt-3 py-2" onClick={handleUploadReqClick}>
                            بارگذاری تصویر فاکتور
                        </Button>
                    </Col>
                </Row>
            </div>


            {/*<h6 style={{marginTop: "4rem"}}>کاربر عزیز</h6>*/}
            <div className="font-weight-300 mt-4 text-justify">
                <ul className="mt-3" style={{paddingInlineStart: '15px'}}>
                    <li>
                        برای استفاده از شرایط اقساطی فروشگاه ها، ابتدا از قسمت درخواست خرید اقساطی فروشگاه مورد نظر را انتخاب کنید
                    </li>
                    <li className="mt-2">
                        سپس خرید خود را در فروشگاه طبق قوانین هر فروشگاه انجام داده و تضامین لازم مانند چک صیادی را به فروشگاه ارائه دهید.
                    </li>
                    <li className="mt-2">
                        پس از اتمام خرید، فاکتور خرید خود را در قسمت بارگذاری تصویر ارسال فرمایید.
                    </li>
                    <li className="mt-2">
                        درصد برگشت وجه پس از تایید فروشگاه به کیف پول شما واریز میشود.
                    </li>
                </ul>
            </div>

            
        </div>

    );
}

export default Installments;